module.exports = __webpack_public_path__ + "img/TechArcherArm2_ua.6f493c19.webp";